'use client';

import { useLocale } from 'next-intl';
import { useState, useEffect } from 'react';
import styles from './HeroTypography.module.css';

export default function HeroTypography() {
  const locale = useLocale();
  const isArabic = locale === 'ar';

  const headlineTop = isArabic ? "مرحباً بكم في" : "Welcome to";
  const headlineHighlight = "ISS Sudan UTM";
  const deck = isArabic
    ? "المنصة الرسمية التي تقدم التوجيه الأكاديمي، والخدمات الطلابية، والبيئة الثقافية الداعمة للطلاب السودانيين في جامعة التكنولوجيا ماليزيا."
    : "The official platform providing academic guidance, student services, and a supportive cultural home for Sudanese students at Universiti Teknologi Malaysia.";

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('heroIntroDone') === 'true') {
      setVisible(true);
      return;
    }
    const onDone = () => setVisible(true);
    window.addEventListener('hero-intro-done', onDone);
    return () => window.removeEventListener('hero-intro-done', onDone);
  }, []);

  return (
    <div className={`${styles.container} ${isArabic ? styles.isRtl : ''} ${visible ? styles.visible : ''}`} dir={isArabic ? 'rtl' : 'ltr'}>
      <h1 className={styles.headline}>
        {headlineTop}<br />
        <span className={styles.highlight} dir="ltr">{headlineHighlight}</span>
      </h1>
      <p className={styles.deck}>{deck}</p>
    </div>
  );
}
